import {
  ESTIMATE_FORM_DEFAULT_VALUES,
  EstimateFormGroup,
  estimateFormSchema,
  type EstimateFormType,
  EstimateTypeSelector,
  useEstimateForm,
} from '@massilia/features'
import { useCreateEstimateMutation } from '@massilia/queries'
import { Button } from '@massilia/ui'
import { useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'

export function EstimateForm() {
  const navigate = useNavigate()
  const createMutation = useCreateEstimateMutation()

  const form = useEstimateForm({
    defaultValues: {
      ...ESTIMATE_FORM_DEFAULT_VALUES,
    } satisfies EstimateFormType,
    onSubmit: async (value) => {
      const parsed = estimateFormSchema.safeParse(value)

      if (!parsed.success) {
        toast.error('Formulaire invalide - Veuillez vérifier les champs')
        return
      }

      createMutation.mutate(parsed.data, {
        onError: () => {
          toast.error('❌ Une erreur est survenue', {
            description: 'Impossible de créer le devis',
          })
        },
        onSuccess: () => {
          navigate({ to: '/estimate-sent' })
        },
      })
    },
  })

  return (
    <form
      className="space-y-6"
      onSubmit={(e) => {
        e.preventDefault()
        e.stopPropagation()
        void form.handleSubmit()
      }}
    >
      <EstimateTypeSelector
        fields={{
          estimateType: 'estimateType',
          type: 'type',
        }}
        form={form}
      />

      <EstimateFormGroup
        fields={{
          clientFirstName: 'clientFirstName',
          clientLastName: 'clientLastName',
          contactEmail: 'contactEmail',
          approximativeBudget: 'approximativeBudget',
          carLoan: 'carLoan',
          companyPreference: 'companyPreference',
          complementaryInformation: 'complementaryInformation',
          contactPhoneNumber: 'contactPhoneNumber',
          departure: 'departure',
          departureDate: 'departureDate',
          departureFlexibilityAfter: 'departureFlexibilityAfter',
          departureFlexibilityBefore: 'departureFlexibilityBefore',
          destination: 'destination',
          estimateType: 'estimateType',
          existingPassengerIds: 'existingPassengerIds',
          flights: 'flights',
          hotelMinimumNumberOfStars: 'hotelMinimumNumberOfStars',
          newPassengers: 'newPassengers',
          onSiteActivities: 'onSiteActivities',
          particularities: 'particularities',
          passengers: 'passengers',
          pension: 'pension',
          returnDate: 'returnDate',
          returnFlexibilityAfter: 'returnFlexibilityAfter',
          returnFlexibilityBefore: 'returnFlexibilityBefore',
          transfertFromAirport: 'transfertFromAirport',
          travelClass: 'travelClass',
          type: 'type',
        }}
        form={form}
      />

      <div className="flex justify-between gap-4 pt-4">
        <Button type="button" variant="ghost" onClick={() => navigate({ to: '/research-bar' })}>
          Retour
        </Button>
        <Button type="submit">Envoyer la demande</Button>
      </div>
    </form>
  )
}
